import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
export const cardHeaderText = (preText, elster) => {
  return "".concat(preText, ": ").concat(createTimezonedDate(elster.start_date, true).toCustomLocaleDateString(), " - ").concat(createTimezonedDate(elster.end_date, true).toCustomLocaleDateString());
};